@if (lexiconEntry(); as entry) {
  <h2>{{entry?.title?.[translate.getCurrentLang()]}}</h2>
  <p appExternalLink [innerHTML]="$safeNavigationMigration(entry?.textshort?.[translate.getCurrentLang()])"></p>
  <details>
    <summary>
      <h3 class="title-further-information">
        {{'further_information' | translate}}
      </h3>
    </summary>
    <p appExternalLink [innerHTML]="$safeNavigationMigration(entry?.textlong?.[translate.getCurrentLang()])"></p>
  </details>
}
